import { LoadingCircleModule } from './../../../shared/component/common/loading-circle/loading-circle.module';
import { RetryModule } from '../../../shared/component/common/retry/retry.module';
import { SearchModule } from '../../../shared/component/common/search/search.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { HeaderModule } from '../../../shared/component/common/header/header.module';
import { ButtonModule } from '../../../shared/component/common/button/button.module';
import { LabelModule } from '../../../shared/component/common/label/label.module';
import { RadioModule } from '../../../shared/component/common/radio/radio.module';
import { TaxResidencyCountryComponent } from './tax-residency-country.component';
import { CharonHttpService, CharonModule } from '../../../../libs/charon';
import { environment } from '../../../../environments/environment';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { Interceptor } from '../../../../app/intercept';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    HeaderModule,
    ButtonModule,
    LabelModule,
    RadioModule,
    SearchModule,
    RetryModule,
    CharonModule
      .withConfig({
        entryPoint: environment.carontePix.entryPoint,
        provider: CharonHttpService,
        payloadCryptography: {
          initSessionUrl: environment.carontePix.initSessionUrl,
          protectedHeader: environment.carontePix.protectedHeader,
        }
      }),
      LoadingCircleModule
  ],
  declarations: [TaxResidencyCountryComponent],
  providers: [
    Interceptor,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: Interceptor,
      multi: true,
    },
  ]
})
export class TaxResidencyCountryComponentModule {}
